/**
 * useClickUpCacheGuard
 *
 * Хук, который следит за навигацией.
 * Когда пользователь уходит с /clickup/* на другой раздел сайта —
 * вызывает clearClickUpCache(), чтобы при следующем входе данные были свежими.
 *
 * При переходах ВНУТРИ /clickup/* кэш НЕ сбрасывается.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { clearClickUpCache } from '../api/clickupCache';

let wasOnClickUp = false;

export function useClickUpCacheGuard() {
    const location = useLocation();

    useEffect(() => {
        const isClickUp = location.pathname.startsWith('/clickup');

        if (wasOnClickUp && !isClickUp) {
            // Уходим с ClickUp — очищаем кэш
            clearClickUpCache();
        }

        wasOnClickUp = isClickUp;
    }, [location.pathname]);
}
